import {
  useQuery,
  type OperationVariables,
  type DocumentNode,
  type QueryHookOptions,
  type QueryResult,
  type TypedDocumentNode,
} from '@apollo/client';
import { deserialize } from '@enmon/commons';

export const useStrapiQuery = <TData = unknown, TVariables = OperationVariables>(
  query: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options?: QueryHookOptions<TData, TVariables>,
): QueryResult<TData, TVariables> => {
  const onCompleted = (data: TData) => options?.onCompleted?.(deserialize(data));

  const { data, ...rest } = useQuery<TData, TVariables>(query, { ...options, onCompleted });

  return {
    data: deserialize(data),
    ...rest,
  };
};
